// src/components/Info.js
import React from 'react';
import './Info.css';

const Info = () => {
  return (
    <div className="info-container">
      <h1>קצת על עצמי</h1>
      <p>
       <p>קוראים לי טל 😊</p> 
        במקור אני מתכנת בחברת הייטק, אבל תמיד הייתה לי תשוקה לפיצות ולבצקים. 
        בין הסבבים שלי במילואים בחטיבת הצנחנים בעזה ובדרום לבנון, גיליתי שהבישול הוא הרבה יותר מתחביב, 
        מצאתי את עצמי עוסק במטבח והבנתי שאני רוצה לקחת את התחום הזה צעד קדימה
      </p>
      <p>
        .היום, אני כאן כדי להביא לכם את הפיצות הכי טעימות, עם חומרי הגלם הטובים ביותר ובליווי שירות אישי ומיוחד
      </p>
      <p>
        !אני מזמין אתכם לשריין תאריך ולהתנסות בחוויה קולינרית שתשאיר לכם טעם של עוד
      </p>
    </div>
  );
};

export default Info;
